if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	/*
		HOME ARROW
		$('.arrow-home').click(function(event) {
			$('body, html').animate({
				scrollTop: $(window).height()-$('header').outerHeight()*2},
				800, 'easeOutExpo');
		});
	*/

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))

	$('.tab-buttons a').click(function (e) {
		e.preventDefault()
		$('.tab-buttons a').removeClass('active')
		$(this).addClass('active')
		var selectedTab = $(this).attr('href')
		$(selectedTab).siblings('.tab-wrapper').removeClass('active')
		$(selectedTab).addClass('active')
		$('.tab-wrapper .sym-slides').slick('unslick')
		$('.tab-wrapper .sym-slides').slick({
			accessibility: false,
		})
	})
	$('.sym-slides').slick({
		accessibility: false,
	})
	$('.accommodations_slider').slick({
		accessibility: false,
		arrows: false,
		dots: false,
	})

	var data = document.URL
	if ($('.section-specials').length > 0 && data.indexOf('?tab-') != '-1') {
		var data = data.split('?')[1]
		var tab = '#' + data.split('&')[0]
		var item_tab = tab + data.split('&')[1]
		$(tab).click()
		setTimeout(function () {
			console.log(item_tab)
			var top_col = $(item_tab).offset().top
			$('html,body')
				.animate({ scrollTop: top_col - 100 }, 2000)
				.delay(1000)
		}, 1000)
	}
})()

// * searchParams
// *
// * search params to url
const searchParams = () => {
	if (window.location.search) {
		const URL = window.location.search.slice(1)
		let paramsURL = URL.split('&')

		paramsURL.forEach((param) => {
			let value = param.split('=')[0]
			let key = param.split('=')[1]

			switch (value) {
				case 'quad': // option quad
					scrollQuad(key)
					break
				case 'clic': // option clic in element
					clicElement(key)
					break
				default:
			}
		})
	}
}

const scrollQuad = (selectorElement) => {
	if (selectorElement === null || selectorElement === '') return

	let target = document.querySelector(`#${selectorElement}`)

	if (target === null) {
		target = document.querySelector(`.${selectorElement}`)
	}

	if (target === null) {
		target = document.querySelector(`[data-tb-quad="${selectorElement}"]`)
	}

	if (target === null) {
		console.error(`ERROR: there is no element with the class, id or data attribute "${selectorElement}"`)
		return
	}

	setTimeout(() => {
		$('html, body').animate({ scrollTop: $(target).offset().top - 100 }, 800)
	}, 600)
}

const clicElement = (selectorElement) => {
	if (selectorElement === null || selectorElement === '') return

	let nodeElement = document.querySelector(`a[href="#${selectorElement}"]`)
	if (nodeElement === null) {
		console.error(`ERROR: it is not possible to found the element`)
		return
	}

	setTimeout(() => {
		nodeElement.click()
	}, 200)
}

const onValidParam = (param) => {
	const URL = window.location.search.slice(1)

	if (URL.indexOf(param) === 0) return true
	return false
}

const onScrollAuto = (sourceSelector) => {
	let htmlQuad = sourceSelector.closest('[data-tb-quad]')
	let idQuad = htmlQuad.getAttribute('id') === null ? htmlQuad.dataset.tbQuad : htmlQuad.getAttribute('id')

	scrollQuad(idQuad)
}

searchParams()



